import { render, staticRenderFns } from "./attendance-gallery.vue?vue&type=template&id=0e4d0581&scoped=true&"
import script from "./attendance-gallery.vue?vue&type=script&lang=js&"
export * from "./attendance-gallery.vue?vue&type=script&lang=js&"
import style0 from "./attendance-gallery.vue?vue&type=style&index=0&id=0e4d0581&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4d0581",
  null
  
)

export default component.exports